import { getPrimaryAccount, getAccountData } from '../../../utils/sessionUtil';

export function financialApi() {
  const MOCK_API = {
    metaData: [
      {
        method: 'GET',
        url: '/vceptpl/api/financialAccountData?start=0&count=9',
        page: 'financialAdvisorDashboard',
      },
    ],
  };

  const API_URLS = {
    metaData: [
      {
        // userData
        method: 'GET',
        url: `/donor-portal/api/account/${
          getPrimaryAccount().userId
        }/getFinancialAdvisorDashboardInfo/${
          getAccountData().partyId
        }?start=0&count=9`,
        page: 'financialAdvisorDashboard',
      },
    ],
  };

  if (process.env.REACT_APP_NODE_ENV === 'development') return MOCK_API;
  return API_URLS;
}

export function lazyApi(lazyCount) {
  const MOCK_API = {
    metaData: [
      {
        method: 'GET',
        url: `/vceptpl/api/lazyData?start=${lazyCount}&count=9`,
        page: 'financialAdvisorDashboard',
      },
    ],
  };

  const API_URLS = {
    metaData: [
      {
        method: 'GET',
        url: `/donor-portal/api/account/${
          getPrimaryAccount().userId
        }/getFinancialAdvisorDashboardInfo/${
          getAccountData().partyId
        }?start=${lazyCount}&count=9`,
        page: 'financialAdvisorDashboard',
      },
    ],
  };

  if (process.env.REACT_APP_NODE_ENV === 'development') return MOCK_API;
  return API_URLS;
}
